'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _siema = require('siema');

var _siema2 = _interopRequireDefault(_siema);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Usps = function () {
  function Usps(el) {
    (0, _classCallCheck3.default)(this, Usps);

    this.el = el;
    // We get the number in the amount of seconds wanted (1, 2, 3, etc.)
    this.timeBetweenSlides = parseInt(this.el.dataset.timeBetweenSlides, 10) * 1000;

    this.resizeFnc = this.resizeFnc.bind(this);

    this.resizeFnc();
    var debouncedResizeFnc = (0, _utils.debounce)(this.resizeFnc, 50);
    window.addEventListener('resize', debouncedResizeFnc);
  }

  (0, _createClass3.default)(Usps, [{
    key: 'startAutoplay',
    value: function startAutoplay() {
      var _this = this;

      this.autoplayInterval = setInterval(function () {
        _this.carousel.next();
      }, this.timeBetweenSlides);

      return this.autoplayInterval;
    }
  }, {
    key: 'clearAutoplay',
    value: function clearAutoplay() {
      clearInterval(this.autoplayInterval);
    }
  }, {
    key: 'resizeFnc',
    value: function resizeFnc() {
      if (window.innerWidth >= _utils.mediaBreakpoints.sm && this.carousel != null) {
        this.destroyCarousel();
      } else if (window.innerWidth < _utils.mediaBreakpoints.sm && this.carousel == null) {
        this.initialiseCarousel();
      }
    }
  }, {
    key: 'initialiseCarousel',
    value: function initialiseCarousel() {
      this.carousel = new _siema2.default({
        selector: '.js-Usps_Items',
        perPage: 1,
        loop: true
      });
      this.startAutoplay();
    }
  }, {
    key: 'destroyCarousel',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.carousel.destroy(true);

              case 2:

                this.clearAutoplay();
                this.carousel = null;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function destroyCarousel() {
        return _ref.apply(this, arguments);
      }

      return destroyCarousel;
    }()
  }]);
  return Usps;
}();

exports.default = Usps;